import { useEffect, useState } from 'react';
import { Release, fetchReleases } from '../../api/site';

/**
 * The release history, newest first: each with its version, date, and
 * changes. R13 (ABC6-07): a changelog — the version and date in a narrow
 * column, the title, summary and highlights beside it.
 */
export default function ReleasesPage() {
  const [releases, setReleases] = useState<Release[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchReleases().then((r) => setReleases(r.releases)).catch((e) => setError(e.message || 'Could not load releases'));
  }, []);

  return (
    <div>
      <p className="releases-intro">Every Form-Magic release and what changed in it, newest first.</p>
      {error && <div className="comm-err">{error}</div>}
      {!releases && !error && <div className="site-empty">Loading…</div>}
      {releases?.map((rel) => (
        <article key={rel.id} className="release">
          <div className="ver-col">
            <span className="ver">v{rel.version}</span>
            <span className="when">
              {new Date(`${rel.released_on}T00:00:00`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </span>
          </div>
          <div>
            <h3>{rel.title}</h3>
            {rel.summary && <p className="summary">{rel.summary}</p>}
            {rel.highlights.length > 0 && (
              <ul>
                {rel.highlights.map((h, i) => <li key={i}>{h}</li>)}
              </ul>
            )}
          </div>
        </article>
      ))}
    </div>
  );
}
